var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-card",
    { staticClass: "full-height bg-white" },
    [
      _c("q-card-title", { staticClass: "text-center bg-primary text-white" }, [
        _vm._v("\n        " + _vm._s(_vm.$t("ranking")) + "\n    ")
      ]),
      _c("q-card-separator"),
      _c(
        "q-card-main",
        { staticClass: "relative-position" },
        [
          _c(
            "q-list",
            { attrs: { "no-border": "", separator: "", striped: "" } },
            [
              _vm._l(_vm.filteredRanking, function(ranking, index) {
                return _vm.filteredRanking.length > 0
                  ? _c(
                      "q-item",
                      { key: index },
                      [
                        _c("q-item-side", [
                          _vm._v(
                            "\n                    # " +
                              _vm._s(index + 1) +
                              "\n                "
                          )
                        ]),
                        _c("q-item-side", [
                          _c("img", {
                            staticClass: "round-avatar",
                            attrs: { src: _vm.getImage(ranking) },
                            on: { error: _vm.imageUrlAlt }
                          })
                        ]),
                        _c("q-item-main", [
                          _c("span", { staticClass: "name" }, [
                            _vm._v(_vm._s(ranking.n))
                          ])
                        ]),
                        ranking.s
                          ? _c(
                              "q-item-side",
                              { staticClass: "text-right" },
                              [
                                _c("q-item-tile", [
                                  _vm._v(_vm._s(_vm.getScore(ranking.s)))
                                ])
                              ],
                              1
                            )
                          : _c(
                              "q-item-side",
                              { staticClass: "text-right" },
                              [
                                _c("q-item-tile", [
                                  _vm._v(_vm._s(_vm.getScore(0)))
                                ])
                              ],
                              1
                            )
                      ],
                      1
                    )
                  : _vm._e()
              }),
              _vm.user_position
                ? _c(
                    "q-item",
                    [
                      _c("q-item-side", [
                        _vm._v(
                          "\n                    # " +
                            _vm._s(_vm.user_position.pos + 1) +
                            "\n                "
                        )
                      ]),
                      _c("q-item-side", [
                        _c("img", {
                          staticClass: "round-avatar",
                          attrs: { src: _vm.getImage(_vm.user_position) },
                          on: { error: _vm.imageUrlAlt }
                        })
                      ]),
                      _c("q-item-main", [
                        _c("span", { staticClass: "name" }, [
                          _vm._v(_vm._s(_vm.user_position.n))
                        ])
                      ]),
                      _vm.user_position.s
                        ? _c(
                            "q-item-side",
                            { staticClass: "text-right" },
                            [
                              _c("q-item-tile", [
                                _vm._v(
                                  _vm._s(_vm.getScore(_vm.user_position.s))
                                )
                              ])
                            ],
                            1
                          )
                        : _c(
                            "q-item-side",
                            { staticClass: "text-right" },
                            [
                              _c("q-item-tile", [
                                _vm._v(_vm._s(_vm.getScore(0)))
                              ])
                            ],
                            1
                          )
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          ),
          _vm.filteredRanking.length > 0
            ? _c(
                "q-list",
                { attrs: { "no-border": "", separator: "", dense: "" } },
                [
                  _c(
                    "q-item",
                    [
                      _c("q-item-main", { staticClass: "text-center" }, [
                        _c(
                          "span",
                          {
                            staticClass: "cursor-pointer text-faded",
                            on: {
                              click: function($event) {
                                return _vm.seeAll()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("see_all")))]
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.loaded && _vm.filteredRanking.length === 0
            ? _c(
                "q-list",
                { attrs: { "no-border": "", separator: "", dense: "" } },
                [
                  _c(
                    "q-item",
                    [
                      _c("q-item-main", { staticClass: "text-center" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("no_ranking_found")) +
                            "\n                "
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "q-inner-loading",
            {
              attrs: { visible: _vm.filteredRanking.length == 0 && !_vm.loaded }
            },
            [_c("q-spinner-dots", { attrs: { size: 60, color: "secondary" } })],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }